var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1585,
    height: 2507,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-143 -726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.5 875.015C237.5 849.326 258.326 828.5 284.015 828.5L1645.98 828.5C1671.67 828.5 1692.5 849.326 1692.5 875.015L1692.5 3078.98C1692.5 3104.67 1671.67 3125.5 1645.98 3125.5L284.015 3125.5C258.326 3125.5 237.5 3104.67 237.5 3078.98Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#3F3F3F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.624 747.5 549.501 747.5 661.5 859.499 661.5 999.5 237.5 999.5 237.5 788.624C237.5 765.912 255.912 747.5 278.624 747.5Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#3F3F3F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 831,
    width: 541,
    height: 330,
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5 903.015C208.5 877.326 229.326 856.5 255.015 856.5L1616.98 856.5C1642.67 856.5 1663.5 877.326 1663.5 903.015L1663.5 3106.98C1663.5 3132.67 1642.67 3153.5 1616.98 3153.5L255.015 3153.5C229.326 3153.5 208.5 3132.67 208.5 3106.98Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#9142FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.461 777.5 523.946 777.5 635.5 889.054 635.5 1028.5 208.5 1028.5 208.5 818.461C208.5 795.839 226.839 777.5 249.461 777.5Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#9142FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 859,
    width: 543,
    height: 330,
    fill: "#9142FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5 935.526C250.5 917.839 264.839 903.5 282.526 903.5L1589.47 903.5C1607.16 903.5 1621.5 917.839 1621.5 935.526L1621.5 3079.47C1621.5 3097.16 1607.16 3111.5 1589.47 3111.5L282.526 3111.5C264.839 3111.5 250.5 3097.16 250.5 3079.47Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxQuestion);
export default __webpack_public_path__ + "static/media/box_question.98edbe6a83871e6e84c5cc221b5aa6be.svg";
export { ForwardRef as ReactComponent };